import {
  ContentSection,
  Doctors,
  Mission,
  TitleAdvantages,
  TitleContentBlock,
  TitleContentDirections,
  TitleContentGallery,
  TitleContentImageBlock,
  TitleContentLink,
  TitleContentVideo,
  TitleReviews,
  TitleContentBeforeAfter,
} from '@/components';

export default function generateBlocks(blocks, size, mb, pb="small",swiperData) {
  return blocks.map((block) => {
    const {
      id,
      type,
      data,
      data: { title, slug },
    } = block;
    switch (type) {
      case 'title-content':
        return (
          <ContentSection pt="none" pb={pb} key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleContentBlock data={data} />
          </ContentSection>
        );
      case 'title-content-image':
        return (
          <ContentSection pt="none" pb={pb} key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleContentImageBlock data={data} />
          </ContentSection>
        );
      case 'title-content-images':
        if (data.images.length) {
          return (
            <ContentSection pt="none" pb={pb} key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
              <TitleContentBeforeAfter data={data} />
            </ContentSection>
          );
        } else {
          return (
            <ContentSection pt="none" pb={pb} key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
              <TitleContentGallery data={data} />
            </ContentSection>
          );
        }
      case 'title-content-directions':
        return (
          <ContentSection pt="none" pb="small" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleContentDirections data={data} />
          </ContentSection>
        );
      case 'title-reviews':
        return (
          <ContentSection pt="none" pb="small" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleReviews data={data} swiperData={swiperData}/>
          </ContentSection>
        );
      case 'title-content-link':
        return (
          <ContentSection pt="none" pb="small" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleContentLink data={data} />
          </ContentSection>
        );
      case 'title-advantages':
        return (
          <ContentSection pt="none" pb="small" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleAdvantages data={data} />
          </ContentSection>
        );
      case 'title-content-video':
        return (
          <ContentSection pt="none" pb="small" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleContentVideo data={data} />
          </ContentSection>
        );
      case 'mission':
        return (
          <ContentSection pt="none" pb="large" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <Mission data={data} />
          </ContentSection>
        );
      case 'doctors':
        return (
          <ContentSection pt="none" pb="large" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <Doctors data={data} swiperData={swiperData}/>
          </ContentSection>
        );
      default:
        return;
    }
  });
}
